import {
  DocumentViewState,
  DocumentModel,
  RootState,
  BaseDocumentSearchModel,
  DocumentVersionModel,
  RelatedDocumentViewModel,
  DocumentPageModel,
  DocumentPageDataModel,
  DocumentActionsModel
} from '@/types';
import { GetterTree } from 'vuex';
import { ObjectUtils } from '@/utils/objectUtils';

export const getters: GetterTree<DocumentViewState, RootState> = {
  currentPage(state): number {
    return state.PageNumber;
  },
  document(state): DocumentModel {
    return state.DocumentModel;
  },
  versionBeingViewed(state): DocumentVersionModel {
    return state.VersionBeingViewed;
  },
  relatedDocumentBeingViewed(state): RelatedDocumentViewModel {
    return state.RelatedDocumentBeingViewed;
  },
  isRelatedDocumentBeingViewed(state): boolean {
    return !ObjectUtils.isNullOrEmpty(state.RelatedDocumentBeingViewed);
  },
  isPageLoading(state): boolean {
    return state.isPageLoading || (!state.documentPage.documentData && !state.DocumentModel.hasNotification);
  },
  isPageLoadingOrConverting(state): boolean {
    return !state.hasDocumentError && (state.isPageLoading || (state.DocumentModel?.isBeingConverted && !state.isConversionSlow));
  },
  hasDocumentError(state): boolean {
    return state.hasDocumentError;
  },
  hasDocumentLoaded(state): boolean {
    return state.hasDocumentLoaded;
  },
  documentSearchModel(state): BaseDocumentSearchModel {
    return state.DocumentSearchModel;
  },
  documentPage(state): DocumentPageModel {
    return state.documentPage;
  },
  isDocumentPageLoaded: (state) => (documentPage: DocumentPageDataModel): boolean => {
    return documentPage && state.documentPage && documentPage.documentId === state.documentPage.documentId && documentPage.pageNumber === state.documentPage.pageNumber;
  },
  isDocumentPageCached: (state) => (documentPageData: DocumentPageDataModel) => {
    const index = state.documentPageCache.findIndex((x: DocumentPageModel) => x.documentId === documentPageData.documentId && x.pageNumber === documentPageData.pageNumber);
    return !(index === -1);
  },
  maximumPagesToCache(state): number {
    return state.maximumNumberOfPagesToCache;
  },
  showLoadingSpinner(state): boolean {
    return state.showLoadingSpinner;
  },
  isPageSplittingSupported(state): boolean {
    return state.DocumentModel && !state.DocumentModel.viewConversionId && !state.DocumentModel.hasNotification && state.DocumentModel.pageSplittingSupported && state.DocumentModel.totalPages !== 1;
  },
  deletedPage(state): DocumentPageModel | null {
    return state.deletedPage;
  },
  isDeleting(state): boolean {
    return state.isDeleting;
  },
  deletedDocumentId(state): number | null {
    return state.deletedDocumentId;
  },
  documentActionsSearchModel(state): BaseDocumentSearchModel | null {
    return state.documentActionsSearch;
  },
  documentActions(state): DocumentActionsModel {
    return state.documentActions;
  },
  isTifOrPdf(state): boolean {
    if (!state.DocumentModel?.fileExtension) {
      return false;
    }

    switch (state.DocumentModel.fileExtension.toUpperCase()) {
      case 'TIF':
      case 'TIFF':
      case 'PDF':
        return true;
      default:
        return false;
    }
  }
};
